import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export enum SetupIntentStatus {
    canceled = 'canceled',
    processing = 'processing',
    requiresAction = 'requiresAction',
    requiresConfirmation = 'requiresConfirmation',
    requiresPaymentMethod = 'requiresPaymentMethod',
    succeeded = 'succeeded'
}

export enum SetupIntentUsage {
    offSession = 'offSession',
    onSession = 'onSession'
}

export type SetupIntent = {
    id: string
    clientSecret: string
    created: number
    customerId: string
    description: string
    lastSetupError: string
    paymentMethod: string
    paymentMethodTypes: string[]
    status: SetupIntentStatus
    usage: SetupIntentUsage
}

export interface ISetupIntentTableColumn extends ITableColumn {
    render?: (item: SetupIntent) => ReactNode;
}

export type ListSetupIntents = {
    listSetupIntents: { items: SetupIntent[], nextToken?: string }
}

export type GetSetupIntent = {
    getSetupIntent: SetupIntent
}

export type CreateSetupIntent = {
    createSetupIntent: SetupIntent
}

export type UpdateSetupIntent = {
    updateSetupIntent: SetupIntent
}

export type DeleteSetupIntent = {
    deleteSetupIntent: string
}
